/**
 *
 * Google hands out several different tracking ids, and they do not all load the same way.
 *
 *   GTM-XXXXXXX   Tag Manager container    ->  googletagmanager.com/gtm.js
 *   G-XXXXXXXXXX  GA4 measurement id       ->  googletagmanager.com/gtag/js
 *   AW-XXXXXXXXX  Google Ads conversion    ->  googletagmanager.com/gtag/js
 *   DC-XXXXXXXX   Floodlight               ->  googletagmanager.com/gtag/js
 *   UA-XXXXXX-Y   Universal Analytics      ->  googletagmanager.com/gtag/js
 *                 (the property type is retired, but gtag is still its correct loader)
 *
 * School Settings offers a single "tracking Id" field, so the type has to be worked out from the
 * prefix. Both the loader (GoogleAnalyticsIntegrationComponent) and the settings screen use the
 * helpers here so they can never disagree about what a given id means.
 *
 */

export type GoogleTrackingIdKind = 'gtm' | 'gtag' | 'invalid';

const TAG_MANAGER_ID = /^GTM-[A-Z0-9]+$/i;
const GTAG_ID = /^(?:G|AW|DC)-[A-Z0-9]+$/i;
const UNIVERSAL_ANALYTICS_ID = /^UA-\d+-\d+$/i;

export function getGoogleTrackingIdKind(trackingId: string): GoogleTrackingIdKind {

  const id = (trackingId ?? '').trim();

  if (TAG_MANAGER_ID.test(id)) {
    return 'gtm';
  }

  if (GTAG_ID.test(id) || UNIVERSAL_ANALYTICS_ID.test(id)) {
    return 'gtag';
  }

  return 'invalid';
}

export function isValidGoogleTrackingId(trackingId: string): boolean {
  return getGoogleTrackingIdKind(trackingId) !== 'invalid';
}
